import { render, staticRenderFns } from "./PrintfulConfigurator.vue?vue&type=template&id=f16085b2&scoped=true"
import script from "./PrintfulConfigurator.vue?vue&type=script&lang=ts&setup=true"
export * from "./PrintfulConfigurator.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./PrintfulConfigurator.vue?vue&type=style&index=0&id=f16085b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f16085b2",
  null
  
)

export default component.exports